// 数值展示格式，保留两位小数
export function formatValue(num) {
  if (!num && num !== 0) {
    return '--'
  }
  if (Number.isInteger(Number(num))) {
    return num
  }
  return Number(num).toFixed(2)
}

/**
 * @description 文字转语音方法
 * @public * @param { text, rate, lang, volume, pitch } object * @param text 要合成的文字内容，字符串
 * @param rate 读取文字的语速 0.1~10  正常1
 * @param lang 读取文字时的语言
 * @param volume  读取时声音的音量 0~1  正常1
 * @param pitch  读取时声音的音高 0~2  正常1
 * @returns SpeechSynthesisUtterance
 */
export function speak({
  text, speechRate, lang, volume, pitch
}, endEvent, startEvent) {
  if (!window.SpeechSynthesisUtterance) {
    console.warn('当前浏览器不支持文字转语音服务')
    return false
  }

  if (!text) {
    return false
  }

  const speechUtterance = new SpeechSynthesisUtterance()
  speechUtterance.text = text
  speechUtterance.rate = speechRate || 1
  speechUtterance.lang = lang || 'zh-CN'
  speechUtterance.volume = volume || 1
  speechUtterance.pitch = pitch || 1
  speechUtterance.onend = () => {
    endEvent && endEvent()
  }
  speechUtterance.onstart = () => {
    startEvent && startEvent()
  }
  speechSynthesis.speak(speechUtterance)

  return speechUtterance
}
/**
 * @param {字符串} str
 * @returns 返回一个对象，对象里面是统计了中文，非中文的字符数量
 */
export function countChineseAndNonChinese(str) {
  if (!str) {
    str = ''
  }
  let chineseCount = 0
  let nonChineseCount = 0
  // eslint-disable-next-line
  for (let i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i)
    if (charCode >= 19968 && charCode <= 40869) {
      // eslint-disable-next-line
      chineseCount++
    } else {
      // eslint-disable-next-line
      nonChineseCount++
    }
  }
  return {
    chineseCount,
    nonChineseCount,
  }
}

// 计算文字宽度
export function computedTextWidth(text, font = '14px') {
  const __span = document.createElement('span')
  __span.style.fontFamily = ''
  __span.innerText = text
  __span.style.fontSize = font
  __span.style.visibility = 'hidden'
  __span.style.position = 'absolute'
  document.body.appendChild(__span)
  const width = __span.offsetWidth
  document.body.removeChild(__span)
  return width
}
